// extracted by mini-css-extract-plugin
export var cardLayout = "_9f-1";
export var paginationContainer = "_9f-0";